/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import DiscordAnalyticsMentorPerformanceDash from "../../../../components/DiscordAnalytics/Mentors/Performance";
import Navbar from "../../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../../constants/routes";

const DiscordAnalyticsMentorPerformance = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.discordAnalytics?.hasMentorPerformanceAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <DiscordAnalyticsMentorPerformanceDash adminConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default DiscordAnalyticsMentorPerformance;
